/**
 * Simple memoize function. It takes a function and a resolver function to generate a
 * cache key
 */
export function memoize(func, resolver) {
    const cache = new Map();
    return function (...args) {
        const key = resolver(...args);
        if (cache.has(key)) {
            return cache.get(key);
        }
        const result = func(...args);
        cache.set(key, result);
        return result;
    };
}
